(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('MatiereController', MatiereController);

    MatiereController.$inject = ['$scope', '$state', 'Matiere', 'MatiereSearch', 'TableService'];

    function MatiereController($scope, $state, Matiere, MatiereSearch, TableService) {

        var vm = this;
        var addItemData = {
            templateUrl: 'app/entities/matiere/matiere-dialog.html',
            controller: 'MatiereDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'sm',
            resolve: {
                entity: function() {
                    return {
                        nom: null,
                        id: null
                    };
                }
            }
        };



        /**
         *Modification d'un élément
         */
        var editItemData = {
            templateUrl: 'app/entities/matiere/matiere-dialog.html',
            controller: 'MatiereDialogController',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        /**
         * Suppresion d'un élément
         */
        var deleteItemData = {
            templateUrl: 'app/entities/matiere/matiere-delete-dialog.html',
            controller: 'MatiereDeleteController',
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                entity: null
            }
        };

        var dialogData = {
            addData: addItemData,
            editData: editItemData,
            deleteData: deleteItemData
        };
        var entitySearchParams = function() {
            return {

            };
        };

        var entityParams = function() {
            return {

            };
        };

        var datas = {
            scope: $scope,
            vm: vm,
            entity: Matiere,
            entitySearch: Matiere,
            dialogData: dialogData,
            entitySearchParams: entitySearchParams,
            entityParams: entityParams
        };
        TableService.init(datas);
    }
})();